
export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/accounts/item-types`,
        name: `${prefix}.item-types.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.accounts.item-types.index`,
                PageDescription: "Accounts master data: Item types",
            },
        },
    },
];
